import { css } from '@emotion/react';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { ListItemFigure, type ListItemFigureProps } from 'client/components/Other/ListItemFigure';
import { ListItemText } from 'client/components/Other/ListItemText';
import { borderRadius } from 'client/Theme';

export interface DropdownMenuBannerProps extends RadixDropdownMenu.DropdownMenuLabelProps {
  title: string;
  subtitle?: string;
  icon?: JSX.Element;
  ornament?: JSX.Element;
  state?: ListItemFigureProps['state'];
}

export const DropdownMenuBanner = ({ title, subtitle, icon, ornament, state, children, ...props }: DropdownMenuBannerProps) => (
  <RadixDropdownMenu.Label css={labelStyle} className="banner" {...props}>
    <ListItemFigure icon={icon} ornament={ornament} state={state} size={32} />
    <ListItemText primary={title} secondary={subtitle} css={textStyle} />
    {children}
  </RadixDropdownMenu.Label>
);

const labelStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 6px;
  padding-top: 14px;
  border-radius: ${borderRadius}px;
`;

const textStyle = css`
  max-width: 24ch;
  text-align: center;
  line-height: 1.2;

  .body1 {
    margin-bottom: 8px;
    justify-content: center;
  }
`;
